import React, { Component } from 'react';
import Cliente from './Cliente';
import listado from '../assets/data/clientes';

class ListadoClientes extends Component {

    componentWillMount() {
        this.clientes = listado.map(cliente => <Cliente key={cliente.nombre} showBorder={cliente.showBorder} image={require('../assets/img/clientes/' + cliente.imagen)} />);
    }

    render() {
        return (
            <div className="row">
                {this.clientes}
            </div>
        );
    }
}

export default ListadoClientes;


// WEBPACK FOOTER //
// ./src/subcomponents/ListadoClientes.js